import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { Col, Row } from 'antd'
import PropTypes from 'prop-types'

import { DateRangePicker } from '../../../core/components'
import { Button, Panel } from '../../../core/components/styled'

import {
  ADMIN,
  DEFINER_JUNIOR_SCRAPER,
  DEFINER_MIDDLE_SCRAPER,
  DEFINER_MIDDLE_SCRAPER_REVIEWER,
  DEFINER_SENIOR_SCRAPER_REVIEWER,
  JUNIOR_SCRAPER,
  MIDDLE_SCRAPER,
  MIDDLE_SCRAPER_REVIEWER,
  QUALITY_CHECKER_SENIOR_SCRAPER_REVIEWER,
  SENIOR_SCRAPER,
  SENIOR_SCRAPER_REVIEWER,
  TEAM_LEADER,
} from '../../../common/constants'

import { UsersDropdown } from '../../../users/components/pages/sections'

import { scrapingVerificationReportSchema } from './schemas'

const ScrapingVerificationReportForm = ({ isGeneratingReport, onSubmit }) => {
  const formMethods = useForm({
    defaultValues: {
      userIds: [],
      dateRange: '',
    },
    resolver: yupResolver(scrapingVerificationReportSchema),
  })

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Panel withBorderBottom>
          <Row type="flex" align="bottom">
            <Col span={5}>
              <UsersDropdown
                name="userIds"
                mode="multiple"
                allowClear
                disableInctiveUsers={false}
                withRoles={[
                  ADMIN,
                  TEAM_LEADER,
                  JUNIOR_SCRAPER,
                  MIDDLE_SCRAPER,
                  SENIOR_SCRAPER,
                  DEFINER_JUNIOR_SCRAPER,
                  DEFINER_MIDDLE_SCRAPER,
                  DEFINER_MIDDLE_SCRAPER_REVIEWER,
                  DEFINER_SENIOR_SCRAPER_REVIEWER,
                  MIDDLE_SCRAPER_REVIEWER,
                  SENIOR_SCRAPER_REVIEWER,
                  QUALITY_CHECKER_SENIOR_SCRAPER_REVIEWER,
                ]}
              />
            </Col>
            <Col span={5} offset={1}>
              <DateRangePicker name="dateRange" label="Date range" />
            </Col>
            <Col span={1} offset={1}>
              <Button
                style={{ marginBottom: '24px' }}
                type="primary"
                htmlType="submit"
                loading={isGeneratingReport}
              >
                Generate scraping verification report
              </Button>
            </Col>
          </Row>
        </Panel>
      </form>
    </FormProvider>
  )
}

ScrapingVerificationReportForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isGeneratingReport: PropTypes.bool.isRequired,
}

export default ScrapingVerificationReportForm
